import React from 'react';
export const WysiwygEditorComponent = function WysiwygEditorComponent({ className, autofocus, editor, children }) {
    const ref = React.useRef(null);
    React.useEffect(() => {
        const { current } = ref;
        if (current) {
            current.appendChild(editor.wysiwygEditor.dom);
            if (autofocus) {
                editor.focus();
            }
        }
    }, [editor]);
    return (React.createElement("div", { ref: ref, className: className }, children));
};
